module.exports = __webpack_public_path__ + "static/media/DesignSmartFull.bd1754f8.svg";